





































import { Component, Vue } from 'vue-property-decorator';
import TitleContainer from '@/components/common/TitleContainer.vue';
import PreCollectionItem from '@/components/pre-collections/PreCollectionItem.vue';
import PreCollectionLoading from '@/components/pre-collections/PreCollectionLoading.vue';
import PreCollectionFilterLoading from '@/components/pre-collections/PreCollectionFilterLoading.vue';
import PurchaseStore, {
  PurchaseStoreInterface,
} from '@/resource/purchase/purchase.store';
import { PreCollection } from '@/resource/pre-collection/pre-collection.model';
import MainButton from '@/main-components/common/MainButton.vue';

@Component({
  components: {
    TitleContainer,
    PreCollectionItem,
    PreCollectionLoading,
    PreCollectionFilterLoading,
    MainButton,
  },
})
export default class PaperCollections extends Vue {
  purchaseStore: PurchaseStoreInterface = PurchaseStore;

  isLoading = false;

  listingAdWidth = 0;

  mainTitle = [
    {
      type: 'normal',
      value: 'Pembelian Saya',
    },
  ];

  get preCollections(): PreCollection[] {
    return this.purchaseStore.purchases.map(purchase => {
      return purchase.precollection;
    });
  }

  async created() {
    this.isLoading = true;
    await this.purchaseStore.fetchPurchasesByUser();
    this.isLoading = false;
  }
}
